<template>
  <div>
    <v-dialog v-model="visible" :max-width="width" :lazy="true">
      <v-card>
        <v-card-title class="headline">
          <div class="headline">
            {{title}}
          </div>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="visible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <slot>
            {{label}}
          </slot>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat="flat" @click.native="visible = false">{{noLabel}}</v-btn>
          <v-btn color="primary" flat="flat" @click.native="doOk">{{yesLabel}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  watch: {
    'value': function (value) {
      this.visible = value
    },
    'visible': function (value) {
      if (!value) {
        // As this components using v-model to pass in value,
        // we have to emit back the value
        this.$emit('input', false)
      }
    }
  },
  methods: {
    doOk() {
      this.$emit('ok')
      this.visible = false
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Are you sure?'
    },
    label: {
      type: String,
      default: ''
    },
    yesLabel: {
      type: String,
      default: 'Yes'
    },
    noLabel: {
      type: String,
      default: 'Cancel'
    },
    width: {
      type: Number,
      default: 400
    }
  },
  beforeMount() {
    // Some init
    this.visible = this.value
  }
}
</script>

<style lang="scss">

</style>
